import React, { Component } from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_RECHAZADOS_EN_CALADO } from '../../../../../../config/tables'

export class TablaCamionesRechazadosEnCaladoView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_CAMIONES_RECHAZADOS_EN_CALADO} />
    )
  }
}
